module.exports = __webpack_public_path__ + "img/13acb5c.png";